import { render, staticRenderFns } from "./GrowingNumber.vue?vue&type=template&id=354901d0&"
import script from "./GrowingNumber.vue?vue&type=script&lang=js&"
export * from "./GrowingNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('354901d0')) {
      api.createRecord('354901d0', component.options)
    } else {
      api.reload('354901d0', component.options)
    }
    module.hot.accept("./GrowingNumber.vue?vue&type=template&id=354901d0&", function () {
      api.rerender('354901d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GrowingNumber.vue"
export default component.exports